import { Injectable } from '@angular/core';
import { AppService } from "../../../../../core/service/Base.Service";

@Injectable()
export class SMBlockactivityService extends AppService<any>{

    constructor() {
        super('SMBlockactivity');
    }

    async GetBlockactivity(refrenceid, typeid) {
        const result = await this.get('Blockactivity', [refrenceid, typeid]);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/shell/forms/school-management/transaction/blockactivity/blockactivity.service.ts